<template>
    <div>
        <el-menu
        :default-active="$router.currentRoute.value.path"
        class="el-menu-demo menu_top_pc"
        mode="horizontal"
        :popper-offset="-3"
        router
        >
        <el-menu-item class="menu_top_pc __link_index" index="/">{{t('__link_index')}}</el-menu-item>
        <el-menu-item class="menu_top_pc __link_code_of_conduct" index="/code_of_conduct">{{t('__link_code_of_conduct')}}</el-menu-item>
        <el-sub-menu  class="menu_top_pc __link_manual_of_new_version" index="3">
        <template #title>{{t('__link_manual_of_new_version')}}</template>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/int_api">{{t('__link_int_api')}}</el-menu-item>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/uint_api">{{t('__link_uint_api')}}</el-menu-item>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/boolfloat_api">{{t('__link_boolfloat_api')}}</el-menu-item>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/bytearray_api">{{t('__link_bytearray_api')}}</el-menu-item>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/atomic_shared_memory">{{t('__link_shared_memory_api')}}</el-menu-item>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/shared_dict">{{t('__link_dict_api')}}</el-menu-item>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/atomic_object_backend">{{t('__link_atomic_object_api')}}</el-menu-item>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/atomic_tools">{{t('__link_atomic_tools')}}</el-menu-item>
            <el-menu-item  class="menu_top_pc el_sub_menu_item" index="/atomic_api_example">{{t('__link_atomic_api_example')}}</el-menu-item>
        </el-sub-menu>
    
        <el-sub-menu class="menu_top_pc __link_historical_version" index="4">
        <template #title>{{t('__link_historical_version')}}</template>
            <el-sub-menu index="4-1" class="menu_top_pc el_sub_menu_item">
            <template #title>v3</template>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/int_api">{{t('__link_int_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/uint_api">{{t('__link_uint_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/boolfloat_api">{{t('__link_boolfloat_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/bytearray_api">{{t('__link_bytearray_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/atomic_shared_memory">{{t('__link_shared_memory_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/list_api">{{t('__link_list_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/set_api">{{t('__link_set_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/string_api">{{t('__link_string_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v3/atomic_object">{{t('__link_procedure_oriented_object_api')}}</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="4-2" class="menu_top_pc el_sub_menu_item">
            <template #title>v2</template>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/int_api">{{t('__link_int_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/uint_api">{{t('__link_uint_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/boolfloat_api">{{t('__link_boolfloat_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/bytearray_api">{{t('__link_bytearray_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/atomic_shared_memory">{{t('__link_shared_memory_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/list_api">{{t('__link_list_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/set_api">{{t('__link_set_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/string_api">{{t('__link_string_api')}}</el-menu-item>
                <el-menu-item class="menu_top_pc el_sub_menu_item" index="/v2/atomic_object">{{t('__link_procedure_oriented_object_api')}}</el-menu-item>
            </el-sub-menu>
        </el-sub-menu>
    
        <el-menu-item index="/payment" class="menu_top_pc __link_enterprise_payment">{{t('__link_enterprise_payment')}}</el-menu-item>
        <el-menu-item index="/enterprise_service" class="menu_top_pc __link_enterprise_service">{{t('__link_enterprise_service')}}</el-menu-item>
        <el-menu-item index="/gitee" class="menu_top_pc __link_gitlab">{{t('__link_gitlab')}}</el-menu-item>
        <el-menu-item index="/about" class="menu_top_pc __link_about">{{t('__link_about')}}</el-menu-item>
        </el-menu>
    
        <div class="menu_top_mobile">
            
            <div class="el_button" @click="isCollapse=(isCollapse === 'none' ? 'block': 'none')">
                <!--<el-button type="primary">:</el-button> -->
                <svg class="icon-font">
                    <use xlink:href="#icon-caidan"></use>
                </svg>
            </div>
            
            <el-menu
                class="el-menu-vertical-demo"
                :default-active="$router.currentRoute.value.path"
                :router="true"
                @select="isCollapse='none'">
                <el-menu-item class="__link_index" index="/">
                    <template #title>
                        {{t('__link_index')}}
                    </template>
                </el-menu-item>

                <el-menu-item class="__link_code_of_conduct" index="/code_of_conduct">
                    <template #title>
                        {{t('__link_code_of_conduct')}}
                    </template>
                </el-menu-item>
                
                <el-sub-menu index="3" class="el_sub_menu">
                    <template #title>
                        <span>{{t('__link_manual_of_new_version')}}</span>
                    </template>
                    <el-menu-item index="/int_api" class="el_sub_menu_item">{{t('__link_int_api')}}</el-menu-item>
                    <el-menu-item index="/uint_api" class="el_sub_menu_item">{{t('__link_uint_api')}}</el-menu-item>
                    <el-menu-item index="/boolfloat_api" class="el_sub_menu_item">{{t('__link_boolfloat_api')}}</el-menu-item>
                    <el-menu-item index="/bytearray_api" class="el_sub_menu_item">{{t('__link_bytearray_api')}}</el-menu-item>
                    <el-menu-item index="/atomic_shared_memory" class="el_sub_menu_item">{{t('__link_shared_memory_api')}}</el-menu-item>
                    <el-menu-item index="/shared_dict" class="el_sub_menu_item">{{t('__link_dict_api')}}</el-menu-item>
                    <el-menu-item index="/atomic_object_backend" class="el_sub_menu_item">{{t('__link_atomic_object_api')}}</el-menu-item>
                    <el-menu-item index="/atomic_tools" class="el_sub_menu_item">{{t('__link_atomic_tools')}}</el-menu-item>
                    <el-menu-item index="/atomic_api_example" class="el_sub_menu_item">{{t('__link_atomic_api_example')}}</el-menu-item>
                </el-sub-menu>

                <el-sub-menu index="4" class="el_sub_menu">
                    <template #title>
                        <span>{{t('__link_v3_manual')}}</span>
                    </template>
                    <el-menu-item index="/v3/int_api" class="el_sub_menu_item">{{t('__link_int_api')}}</el-menu-item>
                    <el-menu-item index="/v3/uint_api" class="el_sub_menu_item">{{t('__link_uint_api')}}</el-menu-item>
                    <el-menu-item index="/v3/boolfloat_api" class="el_sub_menu_item">{{t('__link_boolfloat_api')}}</el-menu-item>
                    <el-menu-item index="/v3/bytearray_api" class="el_sub_menu_item">{{t('__link_bytearray_api')}}</el-menu-item>
                    <el-menu-item index="/v3/atomic_shared_memory" class="el_sub_menu_item">{{t('__link_shared_memory_api')}}</el-menu-item>
                    <el-menu-item index="/v3/list_api" class="el_sub_menu_item">{{t('__link_list_api')}}</el-menu-item>
                    <el-menu-item index="/v3/set_api" class="el_sub_menu_item">{{t('__link_set_api')}}</el-menu-item>
                    <el-menu-item index="/v3/string_api" class="el_sub_menu_item">{{t('__link_string_api')}}</el-menu-item>
                    <el-menu-item index="/v3/atomic_object" class="el_sub_menu_item">{{t('__link_procedure_oriented_object_api')}}</el-menu-item>
                </el-sub-menu>

                <el-sub-menu index="5" class="el_sub_menu">
                    <template #title>
                        <span>{{t('__link_v2_manual')}}</span>
                    </template>
                    <el-menu-item index="/v2/int_api" class="el_sub_menu_item">{{t('__link_int_api')}}</el-menu-item>
                    <el-menu-item index="/v2/uint_api" class="el_sub_menu_item">{{t('__link_uint_api')}}</el-menu-item>
                    <el-menu-item index="/v2/boolfloat_api" class="el_sub_menu_item">{{t('__link_boolfloat_api')}}</el-menu-item>
                    <el-menu-item index="/v2/bytearray_api" class="el_sub_menu_item">{{t('__link_bytearray_api')}}</el-menu-item>
                    <el-menu-item index="/v2/atomic_shared_memory" class="el_sub_menu_item">{{t('__link_shared_memory_api')}}</el-menu-item>
                    <el-menu-item index="/v2/list_api" class="el_sub_menu_item">{{t('__link_list_api')}}</el-menu-item>
                    <el-menu-item index="/v2/set_api" class="el_sub_menu_item">{{t('__link_set_api')}}</el-menu-item>
                    <el-menu-item index="/v2/string_api" class="el_sub_menu_item">{{t('__link_string_api')}}</el-menu-item>
                    <el-menu-item index="/v2/atomic_object" class="el_sub_menu_item">{{t('__link_procedure_oriented_object_api')}}</el-menu-item>
                </el-sub-menu>

                <el-menu-item class="__link_code_of_conduct" index="/payment">
                    <template #title>
                        {{t('__link_enterprise_payment')}}
                    </template>
                </el-menu-item>
                <el-menu-item class="__link_enterprise_service" index="/enterprise_service">
                    <template #title>
                        {{t('__link_enterprise_service')}}
                    </template>
                </el-menu-item>
                <el-menu-item class="__link_gitlab" index="/gitee">
                    <template #title>
                        {{t('__link_gitlab')}}
                    </template>
                </el-menu-item>
                <el-menu-item class="__link_about" index="/about">
                    <template #title>
                        {{t('__link_about')}}
                    </template>
                </el-menu-item>
            </el-menu>
        </div>

    </div>
</template>


<script>
import { useI18n } from "vue-i18n"
import { ref } from 'vue'
import { ElMenu } from 'element-plus'
import { ElMenuItem } from 'element-plus'
import { ElSubMenu } from 'element-plus'
import { ElButton } from 'element-plus'


export default {
    setup() {
        let {t, locale} = useI18n(
            {
                messages: {
                    'en': {
                        "__link_index": "Index"
                        ,"__link_code_of_conduct": "Code of Conduct"
                        ,"__link_manual_of_new_version": "Latest Manual"
                        ,"__link_historical_version": "Historical Versions"
                        ,"__link_v3_manual": "Manual V3"
                        ,"__link_v2_manual": "Manual V2"
                        ,"__link_enterprise_payment": "Buy Enterprise Version"
                        ,"__link_enterprise_service": "Shared Atomic Enterprise Service"
                        ,"__link_gitlab": "Gitlab"
                        ,"__link_about": "About Us"

                        ,"__link_int_api": "Int API:"
                        ,"__link_uint_api": "Unsigned Int API:"
                        ,"__link_boolfloat_api": "Bool and Float API:"
                        ,"__link_bytearray_api": "Bytearray API:"
                        ,"__link_shared_memory_api": "Shared Memory API:"
                        ,"__link_dict_api": "Shared Dict API:"
                        ,"__link_atomic_object_api": "Generic Atomic Object API:"
                        ,"__link_list_api": "List API:"
                        ,"__link_string_api": "String API:"
                        ,"__link_set_api": "Set API:"
                        ,"__link_procedure_oriented_object_api": "Procedure Oriented APIs:"
                        ,"__link_atomic_tools": "Atomic Tools"
                        ,"__link_atomic_api_example": "Lock-free API Example"

                    },
                    'zh_CN': {
                        "__link_index": "主页"
                        ,"__link_code_of_conduct": "编程原则"
                        ,"__link_manual_of_new_version": "新版文档"
                        ,"__link_historical_version": "历史版本"
                        ,"__link_v3_manual": "V3文档"
                        ,"__link_v2_manual": "V2文档"
                        ,"__link_enterprise_payment": "购买企业版"
                        ,"__link_enterprise_service": "企业版服务"
                        ,"__link_gitlab": "Gitlab"
                        ,"__link_about": "关于我们"

                        ,"__link_int_api": "整型API:"
                        ,"__link_uint_api": "无符号整形API："
                        ,"__link_boolfloat_api": "布尔和浮点API："
                        ,"__link_bytearray_api": "字节数组API："
                        ,"__link_shared_memory_api": "共享内存API："
                        ,"__link_dict_api": "共享字典API："
                        ,"__link_atomic_object_api": "通用原子对象API："
                        ,"__link_list_api": "列表API："
                        ,"__link_string_api": "字符串API："
                        ,"__link_set_api": "集合API："
                        ,"__link_procedure_oriented_object_api": "面向过程的API："
                        ,"__link_atomic_tools": "安装工具"
                        ,"__link_atomic_api_example": "无需用锁API示例"
                    },
                    'zh_HK': {
                        "__link_index": "主頁"
                        ,"__link_code_of_conduct": "編程原則"
                        ,"__link_manual_of_new_version": "新版文檔"
                        ,"__link_historical_version": "曆史版本"
                        ,"__link_v3_manual": "V3文檔"
                        ,"__link_v2_manual": "V2文檔"
                        ,"__link_enterprise_payment": "購買企業版"
                        ,"__link_enterprise_service": "企業版服務"
                        ,"__link_gitlab": "Gitlab"
                        ,"__link_about": "關於我們"


                        ,"__link_int_api": "整型API:"
                        ,"__link_uint_api": "無符號整形API："
                        ,"__link_boolfloat_api": "布爾和浮點API："
                        ,"__link_bytearray_api": "字節數組API："
                        ,"__link_shared_memory_api": "共享內存API："
                        ,"__link_dict_api": "共享字典API："
                        ,"__link_atomic_object_api": "通用原子對象API："
                        ,"__link_list_api": "列錶API："
                        ,"__link_string_api": "字符串API："
                        ,"__link_set_api": "集合API："
                        ,"__link_procedure_oriented_object_api": "面嚮過程的API："
                        ,"__link_atomic_tools": "安裝工具"
                        ,"__link_atomic_api_example": "無需用鎖API示例"
                    },
                    'zh_TW': {
                        "__link_index": "主頁"
                        ,"__link_code_of_conduct": "編程原則"
                        ,"__link_manual_of_new_version": "新版文檔"
                        ,"__link_historical_version": "曆史版本"
                        ,"__link_v3_manual": "V3文檔"
                        ,"__link_v2_manual": "V2文檔"
                        ,"__link_enterprise_payment": "購買企業版"
                        ,"__link_enterprise_service": "企業版服務"
                        ,"__link_gitlab": "Gitlab"
                        ,"__link_about": "關於我們"

                        ,"__link_int_api": "整型API:"
                        ,"__link_uint_api": "無符號整形API："
                        ,"__link_boolfloat_api": "布爾和浮點API："
                        ,"__link_bytearray_api": "字節數組API："
                        ,"__link_shared_memory_api": "共享內存API："
                        ,"__link_dict_api": "共享字典API："
                        ,"__link_atomic_object_api": "通用原子對象API："
                        ,"__link_list_api": "列錶API："
                        ,"__link_string_api": "字符串API："
                        ,"__link_set_api": "集合API："
                        ,"__link_procedure_oriented_object_api": "面嚮過程的API："
                        ,"__link_atomic_tools": "安裝工具"
                        ,"__link_atomic_api_example": "無需用鎖API示例"
                    }
                }
            }
        )
        const activeIndex = ref('1')
        const isCollapse = ref("none")

        return {
            t,
            locale,
            activeIndex,
            isCollapse,
        }
    },
    components: {
        ElMenu,
        ElMenuItem,
        ElSubMenu,
        ElButton
    }
}
</script>

<style scoped>
    .is-active {
        background-color: var(--el-menu-hover-bg-color)
    }

    .menu_top_mobile {
        position: relative;
        z-index: 10;
    }

    @media screen and (max-width: 768px){
        .menu_top_pc {
            display: none;
        }

        .menu_top_mobile {
            --el-menu-item-font-size: 3vw;
            --el-menu-item-height: 7vw;
            --el-menu-base-level-padding: 20px;
            --el-menu-sub-item-height: 6vw;
            --el-menu-level-padding: 0;
        }

        .el_button {
            position: absolute;
            right: 0;
            top: 2.4706vw;
        }

        .el-menu-vertical-demo {
            position: absolute;
            right: 0;
            top: 9vw;
            display: v-bind(isCollapse);
            border:solid 1px var(--el-menu-border-color);
            box-shadow: var(--el-box-shadow-light);
            padding: 5px 0;
        }

        .el-menu-vertical-demo .el-menu-item {
            padding: 5px 16px 5px 16px!important;
            line-height: 22px;
        }

        .el_sub_menu {
            padding: 0 0 0 16px;
            --el-menu-icon-width: 3.706vw;
            line-height:6vw;
        }

        .icon-font {
          width: 6.8vw;
          height: 6.8vw;
          vertical-align: center;
          fill: currentColor;
          overflow: hidden;
        }

    }

    @media screen and (max-width: 1080px) and (min-width: 768px){
        .menu_top_pc {
            display: none;
        }

        
        .menu_top_mobile {
            --el-menu-item-font-size: 3vw;
            --el-menu-item-height: 7vw;
            --el-menu-base-level-padding: 20px;
            --el-menu-sub-item-height: 6vw;
            --el-menu-level-padding: 0;
        }
        
        .el_button {
            position: absolute;
            right: 0;
            top: 0;
        }

        .icon-font {
          width: 6.5vw;
          height: 6.5vw;
          vertical-align: center;
          fill: currentColor;
          overflow: hidden;
        }

        .el-menu-vertical-demo {
            position: absolute;
            right: 0;
            top:6vw;
            display: v-bind(isCollapse);
            border:solid 1px var(--el-menu-border-color);
            box-shadow: var(--el-box-shadow-light);
            padding: 5px 0;
        }

        .el-menu-vertical-demo .el-menu-item {
            padding: 0px 16px 0px 16px!important;
            line-height: 4vw;
            height: 4vw;
        }

        .el_sub_menu {
            padding: 0 0 0 16px;
            --el-menu-icon-width: 4vw;
            --el-menu-item-height: 4vw;
            line-height:4vw;
        }

    }

    @media (min-width: 1080px) {
        .menu_top_mobile {
            display: none
        }
        .menu_top_pc {
            font-size: 0.1281rem;
            --el-menu-item-font-size: 0.1281rem;
            --el-menu-base-level-padding: 0.0366rem;
            --el-menu-icon-width: 12px;
            width: 4.6rem;
            flex-shrink: 16;
            text-decoration: none;
            --el-font-size-base: 0.1281rem;
        }

        .__link_about {
            width: v-bind("locale=='en'?'2.1rem':'1.45rem'");
        }
        .__link_enterprise_service,.__link_enterprise_payment{
            width: 2.1rem;
        }
        
        .__link_index {
            flex-shrink: 16;
        }
        .__link_code_of_conduct {
            flex-shrink: 9;
        }
        .__link_manual_of_new_version{
            flex-shrink: 10;
        }
        .__link_historical_version{
            flex-shrink: 10;
        }
        .__link_enterprise_payment{
            flex-shrink: 9;
        }
        .__link_enterprise_service{
            flex-shrink: 9;
        }
        .__link_gitlab{
            flex-shrink: 6;
            width: 2.1rem;
        }
        .el_sub_menu_item{
            width: 1.75rem;
        }
    }



</style>